import React, { useState } from 'react';
import styles from './styles.module.scss';

const GrowWithGuided: React.FC = () => {
  const [activeTab, setActiveTab] = useState('franchising');

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.hero}>
          <h1>Grow with Guidance</h1>
          <p className={styles.subtitle}>
            Transform your hospitality business with our proven systems, expert consulting, and cutting-edge technology
          </p>
        </div>

        <div className={styles.tabs}>
          <div className={styles.tabList}>
            <button
              className={`${styles.tab} ${activeTab === 'franchising' ? styles.active : ''}`}
              onClick={() => setActiveTab('franchising')}
            >
              Franchising
            </button>
            <button
              className={`${styles.tab} ${activeTab === 'consulting' ? styles.active : ''}`}
              onClick={() => setActiveTab('consulting')}
            >
              Consulting
            </button>
            <button
              className={`${styles.tab} ${activeTab === 'technology' ? styles.active : ''}`}
              onClick={() => setActiveTab('technology')}
            >
              Technology
            </button>
          </div>

          {activeTab === 'franchising' && (
            <div className={styles.content}>
              <h2>Franchising</h2>
              <p className={styles.intro}>
                Join the future of hospitality with Guided's proven micro-hotel model. We've perfected the art of creating intimate, high-end accommodations that guests love and operators can run efficiently.
              </p>

              <div className={styles.benefits}>
                <div className={styles.benefitCard}>
                  <h3>Proven Systems</h3>
                  <p>Access our battle-tested operational playbooks and training programs that ensure consistent excellence across all properties.</p>
                </div>

                <div className={styles.benefitCard}>
                  <h3>Premium Experience</h3>
                  <p>Deliver exceptional guest experiences with our carefully crafted service standards and attention to detail.</p>
                </div>

                <div className={styles.benefitCard}>
                  <h3>Operational Support</h3>
                  <p>Benefit from our comprehensive support system, from pre-opening to ongoing operations and quality control.</p>
                </div>
              </div>

              <a href="/franchise" className={styles.ctaButton}>Apply to Franchise</a>
            </div>
          )}

          {activeTab === 'consulting' && (
            <div className={styles.content}>
              <h2>Consulting</h2>
              <p className={styles.intro}>
                Transform your existing property or launch a new venture with our expert consulting services. We bring our operational excellence to your business.
              </p>

              <div className={styles.benefits}>
                <div className={styles.benefitCard}>
                  <h3>Space Design & Optimization</h3>
                  <p>Maximize your property's potential with our space planning and design expertise, focused on guest experience and operational efficiency.</p>
                </div>

                <div className={styles.benefitCard}>
                  <h3>Operational Excellence</h3>
                  <p>Implement our proven staffing models, revenue systems, and service standards to elevate your guest experience.</p>
                </div>

                <div className={styles.benefitCard}>
                  <h3>Growth Strategy</h3>
                  <p>Develop a clear path to success with our strategic planning and implementation support.</p>
                </div>
              </div>

              <a href="/consulting" className={styles.ctaButton}>Book a Consultation</a>
            </div>
          )}

          {activeTab === 'technology' && (
            <div className={styles.content}>
              <h2>Technology</h2>
              <p className={styles.intro}>
                Experience the future of hospitality operations with our proprietary AI-powered system, designed specifically for micro-hotels.
              </p>

              <div className={styles.benefits}>
                <div className={styles.benefitCard}>
                  <h3>Smart Guest Communication</h3>
                  <p>Seamlessly manage guest interactions through WhatsApp integration, automated messaging, and personalized service delivery.</p>
                </div>

                <div className={styles.benefitCard}>
                  <h3>Efficient Operations</h3>
                  <p>Streamline your daily operations with our intelligent task management and workforce optimization tools.</p>
                </div>

                <div className={styles.benefitCard}>
                  <h3>Revenue Management</h3>
                  <p>Maximize your property's performance with our advanced reservation and pricing systems.</p>
                </div>
              </div>

              <a href="/technology" className={styles.ctaButton}>See Our Tech in Action</a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GrowWithGuided; 